<template lang="pug">
    select(v-model="seconds",:disabled="disabled")
        option(v-for="range in ranges",:value="range.seconds") {{range.label}}
</template>

<script>
export default {
  props: ["initial", "disabled"],
  data: () => ({
    seconds: null,
    ranges: [
      { seconds: 60, label: "1 minute" },
      { seconds: 60 * 10, label: "10 minute" },
      { seconds: 60 * 60, label: "1 hour" },
      { seconds: 60 * 60 * 8, label: "8 hour" },
      { seconds: 60 * 60 * 24, label: "1 day" },
      { seconds: 60 * 60 * 24 * 2, label: "2 days" },
      { seconds: 60 * 60 * 24 * 3, label: "3 days" },
      { seconds: 60 * 60 * 24 * 7, label: "7 days" },
      { seconds: 60 * 60 * 24 * 30, label: "30 days" },
      { seconds: 60 * 60 * 24 * 365, label: "1 year" }
    ]
  }),
  mounted() {
    this.seconds = this.initial;
  },
  watch: {
    seconds() {
      this.$emit("change", this.seconds);
    }
  }
};
</script>

